import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SectorsOverview } from '../../constants/types';
import SectorSummaryRow from './SectorSummaryRow';

interface SectorCategory {
    id: number;
    name: string;
    relevantDate: string;
}

interface SectorsOverviewSectionProps {
    sectorsOverview: SectorsOverview[];
    zeroBouldersSectors: SectorCategory[];
    upcomingClosingSectors: SectorCategory[];
    latestOpeningSector: SectorCategory | undefined;
}

const SectorsOverviewSection: React.FC<SectorsOverviewSectionProps> = ({
    sectorsOverview,
    zeroBouldersSectors,
    upcomingClosingSectors,
    latestOpeningSector,
}) => {
    const navigate = useNavigate();

    return (
        <div
            className="group relative bg-white rounded-lg p-4 cursor-pointer transition-all duration-200 hover:shadow-md hover:ring-1 hover:ring-backoffice-200 hover:bg-grey-25 w-full"
            onClick={() => navigate('/sectors-details')}
        >
            <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity text-backoffice-400">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
                </svg>
            </div>

            <div className='w-full'>
                <div className='bold large3 flex items-baseline'>Etat de l'ouverture</div>
                <div className='text-grey-500 regular normal'>Clique sur un secteur pour consulter les blocs actuels</div>
            </div>

            <div className='flex flex-col gap-4 mt-4'>
                <div className="sectors-tab" style={{ width: '100%', minWidth: '100%' }}>
                    <div className="sectors-tab-header bold lower">
                        <div className='sector-header-name'>Derniers secteurs ouverts</div>
                        <div className='sector-header-count'>Blocs</div>
                        <div className='sector-header-opening'>Ouverture</div>
                        <div className='sector-header-closing'>Démontage</div>
                        <div className='sector-header-modify'></div>
                    </div>
                    <div className="sectors-tab-rows">
                        {sectorsOverview && sectorsOverview.map((sector, index) => {
                            return (
                                <SectorSummaryRow
                                    key={index}
                                    countBoulder={sector.countBoulders}
                                    id={sector.id}
                                    name={sector.name}
                                    openingDate={sector.openingDate}
                                    plannedDismantling={sector.plannedClosingDate}
                                />
                            )
                        })}
                    </div>
                </div>

                <div className='flex flex-row gap-6'>
                    {zeroBouldersSectors.length > 0 &&
                        <div className='p-3 rounded-lg border border-orange-500 bg-orange-25'>
                            <div className='bold normal'>
                                Secteur(s) démonté(s)
                            </div>
                            {zeroBouldersSectors.slice(0, 3).map((sector, index) => (
                                <div key={index} className='mt-2'>
                                    <div className='regular normal'>
                                        {sector.name}
                                    </div>
                                    <div className='light lower2'>
                                        {sector.relevantDate}
                                    </div>
                                </div>
                            ))}
                            {zeroBouldersSectors.length > 3 &&
                                <div>...</div>
                            }
                        </div>
                    }
                    {upcomingClosingSectors && upcomingClosingSectors.length > 0 &&
                        <div className='p-3 rounded-lg border border-red-500 bg-red-25'>
                            <div className='bold normal'>
                                Ouverture en retard
                            </div>
                            {upcomingClosingSectors.slice(0, 3).map((sector, index) => (
                                <div key={index} className='mt-2'>
                                    <div className='regular normal'>
                                        {sector.name}
                                    </div>
                                    <div className='light lower2'>
                                        {sector.relevantDate}
                                    </div>
                                </div>
                            ))}
                            {upcomingClosingSectors.length > 3 &&
                                <div>...</div>
                            }
                        </div>
                    }
                    {latestOpeningSector &&
                        <div className='p-3 rounded-lg border border-secondary-700 bg-secondary-25'>
                            <div className='bold normal'>
                                Dernière ouverture
                            </div>
                            <div className='mt-2'>
                                <div className='regular normal'>
                                    {latestOpeningSector.name}
                                </div>
                                <div className='light lower2'>
                                    {latestOpeningSector.relevantDate}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default SectorsOverviewSection;
